import { useDispatch } from "react-redux";

import { useTypedSelector } from "../hooks";
import { PanelState, panelStateSlice } from "../slices/panelStateSlice";

export const usePanelState = (
  panelName: keyof PanelState,
  initialState: boolean
): PanelStateResult => {
  const dispatch = useDispatch();
  const state =
    useTypedSelector(({ panelState }) => panelState)[panelName] ?? initialState;
  return [
    state,
    (nextValue): void => {
      const action = panelStateSlice.actions.set({
        panel: panelName,
        value: nextValue ?? !state,
      });
      dispatch(action);
    },
  ];
};

export type PanelStateResult = [boolean, (value: boolean) => void];

export const createPanelStateHook =
  (panelName: keyof PanelState, initialState: boolean) =>
  (
    currentPanelName: keyof PanelState = panelName,
    currentInitialState: boolean = initialState
  ): PanelStateResult =>
    usePanelState(currentPanelName, currentInitialState);
